// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2J6LB","header":"PatientBlock_header__uDdoB","label":"PatientBlock_label__3F7Lx","option":"PatientBlock_option__Vs9vk"};